import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './manufacture.css'

const Manufacture = (props) => {
  return (
    <div className="manufacture-container">
      <Helmet>
        <title>
          Производственная база Arcobo | Металлообработка в Казахстане
        </title>
        <meta
          name="description"
          content="Собственная производственная база Arcobo: лазерная, гидроабразивная и плазменная резка, механическая обработка, сварка и локализация производства узлов в Алматы"
        />
        <meta
          property="og:title"
          content="Производственная база Arcobo | Металлообработка в Казахстане"
        />
        <meta
          property="og:description"
          content="Собственная производственная база Arcobo: лазерная, гидроабразивная и плазменная резка, механическая обработка, сварка и локализация производства узлов в Алматы"
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Производственная база Arcobo | Металлообработка в Казахстане"
        />
        <meta
          name="twitter:description"
          content="Собственная производственная база Arcobo: лазерная, гидроабразивная и плазменная резка, механическая обработка, сварка и локализация производства узлов в Алматы"
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/manufacture"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/manufacture"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Manufacture","item":"https://arcobo.tech/manufacture"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name20"></HeaderMain>
      <Componenttextimage
        image1Src="/0_Main_page/main_00-1500w.webp"
        image1Alt="Промышленная роботизация Arcobo"
        rootClassName="componenttextimageroot-class-name10"
        textComponent={
          <Fragment>
            <span className="manufacture-text10">
              <span>
                Инженерный центр Arcobo расположен в Алматы и объединяет
                конструкторский отдел, производственный участок и зону испытаний
                роботизированных комплексов.
              </span>
              <br></br>
              <br></br>
              <span className="H1_extrasmall">
                Это позволяет выполнять полный цикл работ внутри компании:
              </span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>проектирование роботизированных систем;</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>изготовление металлоконструкций и оснастки;</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>механическую обработку деталей;</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>сборку электрических шкафов управления;</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>программирование и тестирование оборудования;</span>
              <br></br>
              <span>
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>приемочные испытания перед поставкой заказчику.</span>
              <br></br>
            </span>
          </Fragment>
        }
        componentTitle="Производственная база"
      ></Componenttextimage>
      <Component3images
        image1Src="/Production/production_01-200h.webp"
        image1Alt="Производственная база Arcobo"
        image2Src="/Production/production_02-200h.webp"
        image2Alt="Производственная база Arcobo"
        image3Src="/Production/production_03-200h.webp"
        image3Alt="Производственная база Arcobo"
        rootClassName="component3imagesroot-class-name17"
      ></Component3images>
      <Component3images
        image1Src="/Production/production_11-200h.webp"
        image1Alt="Производственная база Arcobo"
        image2Src="/Production/production_12-200h.webp"
        image2Alt="Производственная база Arcobo"
        image3Src="/Production/production_13-200h.webp"
        image3Alt="Производственная база Arcobo"
        rootClassName="component3imagesroot-class-name16"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="manufacture-text34">
              <span>
                Инженерный и производственный центр Arcobo расположен в Алматы,
                71-ый разъезд. Здесь выполняются изготовление
                металлоконструкций, механическая обработка, сборка
                роботизированных комплексов, программирование, испытания и
                подготовительные операции к вводу в эксплуатацию.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="manufacture-text37">
              <span>
                Производственная база Arcobo позволяет выполнять полный цикл
                изготовления металлических изделий, включая лазерную,
                механическую, гидроабразивную и плазменную резку, токарную и
                фрезерную обработку, гибку, сварку и сборку металлоконструкций.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="manufacture-text40">
              <span>
                Собственная производственная база позволяет сократить сроки
                изготовления, контролировать качество на всех этапах проекта,
                быстрее вносить изменения в конструкцию и локализовать
                производство оборудования в Казахстане. Это снижает зависимость
                от зарубежных поставщиков и ускоряет запуск проектов.
              </span>
              <br></br>
              <span>
                Нами полностью локализовано изготовление шкафов управления РТК.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="manufacture-text45">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Arcobo самостоятельно проектирует роботизированные комплексы,
                изготавливает металлоконструкции и оснастку, собирает шкафы
                управления, выполняет программирование промышленных роботов,
                проводит испытания и ввод оборудования в эксплуатацию.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="manufacture-text50">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Компания разрабатывает и производит специализированные
                роботизированные комплексы, технологическую оснастку, сварочные
                позиционеры, рабочие станции, защитные ограждения и другое
                нестандартное оборудование в соответствии с требованиями
                заказчика.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="manufacture-text55">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Производственная база Arcobo позволяет выполнять изготовление
                отдельных деталей, металлоконструкций, сварных узлов,
                технологической оснастки и компонентов оборудования без заказа
                полного роботизированного комплекса.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="manufacture-text60">
              <span>
                Arcobo выполняет проекты для предприятий металлургии,
                нефтегазовой отрасли, нефтесервиса, машиностроения, энергетики,
                горнодобывающей промышленности, транспортного машиностроения, а
                также научных и образовательных организаций.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="manufacture-text63">answer</span>
          </Fragment>
        }
        showDiv={false}
        showDiv1={false}
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        showDiv6={false}
        showDiv7
        question1="Где расположена производственная база Arcobo?"
        question2="Какие виды металлообработки доступны на производственной базе?"
        question3="Какие преимущества дает собственное производство?"
        question4="Выполняет ли Arcobo полный цикл изготовления роботизированных комплексов?"
        question5="Изготавливает ли Arcobo нестандартное оборудование под заказ?"
        question6="Можно ли заказать только изготовление деталей без роботизации?"
        question7="Какие отрасли обслуживает производственная база Arcobo?"
        rootClassName="componentfaqroot-class-name9"
      ></Componentfaq>
      <FooterMain rootClassName="footer-mainroot-class-name20"></FooterMain>
    </div>
  )
}

export default Manufacture
